import React from 'react';
import { hot } from 'react-hot-loader/root';
import _ from 'root/libs/exaforte/react/lodash';
import TouchableArea from 'root/libs/exaforte/react/TouchableArea';
import Config from 'root/globals/Config';
import { View, Text, Image, ActivityIndicator } from 'react-native';
import ActivationSuccesView from './ActivationSuccesView';
import { withStyles } from '@material-ui/core/styles';
import { FieldSet } from 'root/globals/Form';
import { CustomTextField } from 'root/libs/exaforte/react/Form';
import CustomComponent from 'root/libs/exaforte/react/CustomComponent';
import { Button } from 'root/globals/Elements';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEngineWarning, faLockAlt, faEnvelope, faUser } from '@fortawesome/pro-regular-svg-icons';
import InputAdornment from '@material-ui/core/InputAdornment';

import RetinaImage from 'react-retina-image';

import defaults from 'root/globals/Defaults.less';
import view from './View.less';

const styles = {...defaults, ...view};

const CustomTextFieldSet = withStyles({
    root: {
        width: '100%',
        padding: '3px 19px',
        backgroundColor: '#F8F8F8',
        
        '& .MuiInputBase-adornedStart': {
            border: 'none'
        },
        
        '& .MuiInputLabel-root': {
            display: 'none'
        },
        
        '& .MuiInput-input': {
            border: 0,
            borderRadius: 0,
            fontSize: 16,
            fontWeight: 400,
            backgroundColor: 'transparent',
            
            '&:focus': {
                padding: '11px 12px 9px',
                borderWidth: 0,
            },
        },
        
        '& .MuiFormHelperText-root.Mui-error': {
            display: 'none'
        },
        
        '@media only screen and (max-width: 575px)': {
            width: '100%'
        }
    }
})(FieldSet);


export default hot(class LoginView extends React.Component {
    constructor(props) {
        super(props);
        
        this.environment_id = window.location.host.includes('secure-it') ? 1 : 2;
        this.url_params     = _.get_url_params(window.location.href);
        this.decodedHash    = _.is_empty(this.url_params.hash) ? { } : JSON.parse(atob(this.url_params.hash));
        this.state          = {
            screen  : this.url_params.hash ? 'activate-account' : 'login', 
            email   : this.url_params.hash ? this.decodedHash.email : '', 
            password: '',
            code    : '',
            user    : null
        };
    }
    
    render() {
        let Screen = LoginScreen;
        
        switch(this.state.screen)
        {
            case 'activate-account' : Screen = ActivateAcountScreen; break;
            case 'request-password' : Screen = ForgotPasswordScreen; break;
            case 'activation-succes': Screen = ActivationSuccesView; break;
            case 'two-factor'       : Screen = TwoFactorAuthenticationScreen; break;
        }
        
        if(Screen == ActivationSuccesView)
            return (
                <View className={['py-5', styles['background-color-grey-10'], styles['login-screen']]}>
                    <Screen user={this.state.user} />
                </View>
            );
        
        return (
            <Image source={Config.GLOBAL_IMAGES_URL + 'login-background.png'} className={['position-relative d-flex flex-column justify-content-center align-items-center pt-3 pt-sm-0', styles['background-color-light-blue-10'], styles['login-screen']]}>
                <View className={['position-absolute d-flex flex-row align-items-center', styles['logo']]}>
                    {this.environment_id == 1 ? <>
                        <RetinaImage src={['https://www.secure-it.nl/files/images/secureit-icon-blue.png', 'https://www.secure-it.nl/files/images/secureit-icon-blue@2x.png']} forceOriginalDimensions={false} className={['mr-2', styles['logo-image']].join(' ')} />
                        <Text className={['font-weight-bolder', styles['color-light-blue'], styles['f-1-7-5'], styles['f-sm-2-5']]}>Secure-IT</Text>
                    </> : <Image source={'https://www.facil-it.nl/files/images/Facil-it_logo.svg'} className={[styles['facil-logo-image']]} />}
                </View>
                <View className={['d-flex flex-row align-items-end']}>
                    <Image source={Config.GLOBAL_IMAGES_URL + (this.environment_id == 1 ? 'woman-hands-behind-back.png' : 'man-cleaning-with-buckets.png')} native={true} className={['d-none d-md-block mr-2 mb-n4']} />
                    <Screen parent={this} />
                    <Image source={Config.GLOBAL_IMAGES_URL + (this.environment_id == 1 ? 'man-hands-in-front.png' : 'woman-cleaning-with-bucket.png')} native={true} className={['d-none d-md-block ml-2']} />
                </View>
            </Image>
        );
    }
});

class LoginScreen extends React.Component {
    constructor(props) {
        super(props);
        
        this.state          = {
            attempting_login: false, 
            attempt_failed  : false,
            error           : null,
        };
        
        this._login         = this._login.bind(this);
        this._onChange      = this._onChange.bind(this);
        this._inputKeyDown  = this._inputKeyDown.bind(this);
    }
    
    _login() {
        this.setState({attempting_login: true});
        
        fetch(Config.SERVER_REQUEST_URL + '?ajax_id=10243&form-action=view', {method: 'POST', xhrFields: { withCredentials: true }, credentials: 'include', body: _.json_to_form_data({email: this.props.parent.state.email, password: this.props.parent.state.password})}).then(response => response.json()).then(response => {
            const state = { attempting_login: false, attempt_failed: !_.is_empty(response.error) || !response.status };
            
            if(response.status) {
                if(!response.two_factor_enabled)
                    window.location.reload();
                else if(!_.is_empty(response.error))
                    state.error = response.error;
                else
                    this.props.parent.setState({ screen: 'two-factor', user: response.user });     
            }
            
            this.setState(state);
        }, () => {
            this.setState({attempting_login: false, attempt_failed: true, error: null });
        });
    }
    
    _onChange(field, text) {
        if(this.state.attempting_login)
            return;
            
        this.props.parent.setState({[field]: text});
        
        if(this.state.attempt_failed)
            this.setState({ attempt_failed: false, error: null });
    }
    
    _inputKeyDown(e) {
        if(e.key == 'Enter')
            this._login();
    }
    
    render() {
        return (
            <View className={['d-flex flex-column justify-content-center mx-5 p-4 p-md-5', styles['background-color-white'], styles['container']]}>
                <View className={['w-100 d-flex flex-column my-5 py-4', styles['container-content']]}>
                    <View className={['d-flex flex-column']}>
                        <Text className={[(this.state.attempt_failed ? '' : 'mb-2 ') + 'pb-2', styles['color-light-blue'], styles['f-4-2-5'], styles['text-bold'], styles['text-align-center'], styles['font-montserrat']]}>Inloggen</Text>
                        {this.state.attempt_failed && (
                            <View className={[styles['background-color-red-pink-10'], styles['color-red-pink'], 'd-flex flex-row p-3 mb-4']}>
                                <FontAwesomeIcon icon={faEngineWarning} className={styles['f-3-5']} />
                                <Text className={['ml-2', styles['f-1-5'], styles['f-sm-2']]}>{this.state.error || 'Email of wachtwoord klopt niet'}</Text>
                            </View>
                        )}
                        <View className={['mb-3']}>
                            <CustomTextField autoFocus placeholder="Email" value={this.props.parent.state.email} onChangeText={email => this._onChange('email', email)} wrapper={CustomTextFieldSet} type="email" startAdornment={<InputAdornment position="start"><FontAwesomeIcon icon={faUser} className={styles['color-light-blue']} /></InputAdornment>} inputProps={{onKeyDown: this._inputKeyDown}} {...(this.state.attempt_failed ? {error: '1'} : {})} />
                        </View>
                        <View className={['mb-2']}>
                            <CustomTextField placeholder="Wachtwoord" value={this.props.parent.state.password} onChangeText={password => this._onChange('password', password)} wrapper={CustomTextFieldSet} type="password" startAdornment={<InputAdornment position="start"><FontAwesomeIcon icon={faLockAlt} className={styles['color-light-blue']} /></InputAdornment>} inputProps={{onKeyDown: this._inputKeyDown}} {...(this.state.attempt_failed ? {error: '1'} : {})} />
                        </View>
                        <View className={['d-flex flex-row justify-content-end justify-content-sm-end mb-4']}>
                            <TouchableArea className={[styles['color-light-blue'], styles['text-underline'], styles['f-0-7-5'], styles['f-0-5']]} onPress={() => this.props.parent.setState({screen: 'request-password'})}>Wachtwoord vergeten</TouchableArea>
                        </View>
                    </View>
                    <Button className={['px-5 py-2 text-center align-self-center', styles['login-button']]} {...(!this.state.attempting_login ? {onPress: this._login} : {})}>{!this.state.attempting_login ? (<Text className={[styles['font-montserrat'], styles['text-bold'], styles['f-1-5']]}>Log in</Text>) : (<ActivityIndicator />)}</Button>
                </View>
            </View>
        );
    }
}

class TwoFactorAuthenticationScreen extends CustomComponent {
    constructor(props) {
        super(props);
        
        this.state          = { 
            attempting_verify       : false, 
            attempt_failed          : false,
            error                   : null,
            resend_cooldown_until   : null,
        };
    }
    
    _verify() {
        this.setState({ attempting_verify: true });
        
        fetch(Config.SERVER_REQUEST_URL + '?ajax_id=12857&form-action=view', { method: 'POST', xhrFields: { withCredentials: true }, credentials: 'include', body: _.json_to_form_data({ code: this.props.parent.state.code.trim(), user_id: this.props.parent.state.user }) }).then(response => response.json()).then(response => {
            if(response.status)
                window.location.reload();
            
            this.setState({ attempting_verify: false, attempt_failed: !response.status, error: response.error });
        }, () => {
            this.setState({ attempting_verify: false, attempt_failed: true });
        });
    }
    
    _resend() {
        const now = Date.now();
        
        if (this.state.resend_cooldown_until && now < this.state.resend_cooldown_until) {
            const seconds = Math.ceil((this.state.resend_cooldown_until - now) / 1000);
            this.setState({ attempt_failed: true, error: `Wacht ${seconds} seconden voordat je opnieuw een code kunt versturen.` });
            
            return;
        }
        
        this.props.parent.setState({code: ''});
        this.setState({ attempting_verify: true });
        
        fetch(Config.SERVER_REQUEST_URL + '?ajax_id=12865&form-action=view', { method: 'POST', xhrFields: { withCredentials: true }, credentials: 'include', body: _.json_to_form_data({ user_id: this.props.parent.state.user }) }).then(response => response.json()).then(response => {
            const state = { attempting_verify: false, attempt_failed: !response.status };
            
            if(response.status) {
                state.resend_cooldown_until = Date.now() + 60 * 1000;
                state.error                 = null;
            } else
                state.error = 'Het opnieuw versturen van de verificatie-code ging fout. Probeer het nog een keer.'
            
            this.setState(state);
        }, () => {
            this.setState({ attempting_verify: false, attempt_failed: true, error: null });
        });
    }
    
    _onChange(field, text) {
        if(this.state.attempting_verify)
            return;
            
        this.props.parent.setState({[field]: text});
        
        if(this.state.attempt_failed)
            this.setState({ attempt_failed: false, error: null });
    }
    
    _inputKeyDown(e) {
        if(e.key == 'Enter')
            this._verify();
    }
    
    render() {
        return (
            <View className={['d-flex flex-column justify-content-center mx-5 p-4 p-md-5', styles['background-color-white'], styles['container']]}>
                <View className={['w-100 d-flex flex-column my-5 py-4', styles['container-content']]}>
                    <View className={['d-flex flex-column']}>
                        <Text className={[(this.state.attempt_failed ? '' : 'mb-2 ') + 'pb-2', styles['color-light-blue'], styles['f-4-2-5'], styles['text-bold'], styles['text-align-center'], styles['font-montserrat']]}>2FA verificatie</Text>
                        <Text className={['mb-' + (_.is_empty(this.state.error) ? '4' : '3') + ' font-weight-light text-center', styles['font-roboto'], styles['f-1'], styles['f-sm-1-7-5'], styles['line-height-1'], styles['line-height-sm-1-5'], styles['color-grey']]}>Er is een verificatie-code naar je e-mailadres verstuurd.</Text>
                        {this.state.attempt_failed && (
                            <View className={[styles['background-color-red-pink-10'], styles['color-red-pink'], 'd-flex flex-row p-3 mb-4']}>
                                <FontAwesomeIcon icon={faEngineWarning} className={styles['f-3-5']} />
                                <Text className={['ml-2', styles['f-1-5'], styles['f-sm-2']]}>{this.state.error || 'De 2FA code is incorrect'}</Text>
                            </View>
                        )}
                        <View className={['mb-2']}>
                            <CustomTextField autoFocus placeholder="Code" value={this.props.parent.state.code} onChangeText={code => this._onChange('code', code)} wrapper={CustomTextFieldSet} startAdornment={<InputAdornment position="start"><FontAwesomeIcon icon={faLockAlt} className={styles['color-light-blue']} /></InputAdornment>} inputProps={{onKeyDown: this._inputKeyDown}} {...(this.state.attempt_failed ? {error: '1'} : {})} />
                        </View>
                        <View className={['d-flex flex-row justify-content-end justify-content-sm-end mb-4']}>
                            <TouchableArea className={[styles['color-light-blue'], styles['text-underline'], styles['f-0-7-5'], styles['f-0-5']]} onPress={this._resend}>Code opnieuw versturen</TouchableArea>
                        </View>
                    </View>
                    <Button className={['mt-4 px-5 py-2 text-center align-self-center', styles['login-button']]} {...(!this.state.attempting_verify ? {onPress: this._verify} : {})}>{!this.state.attempting_verify ? (<Text className={[styles['font-montserrat'], styles['text-bold'], styles['f-1-5']]}>Verifieer</Text>) : (<ActivityIndicator />)}</Button>
                </View>
            </View>
        );
    }
}

class ForgotPasswordScreen extends React.Component {
    constructor(props) {
        super(props);
        
        this.state                  = {waiting_response: false, error: ''};
        this._requestNewPassword    = this._requestNewPassword.bind(this);
        this._onChange              = this._onChange.bind(this);
        this._inputKeyDown          = this._inputKeyDown.bind(this);
    }
    
    _requestNewPassword() {
        if(_.is_empty(this.props.parent.state.email))
            this.setState({error: 'Email is verplicht'});
        else
        {
            this.setState({waiting_response: true});
            
            fetch(Config.SERVER_REQUEST_URL + '?ajax_id=10248&form-action=view', {method: 'POST', xhrFields: { withCredentials: true }, credentials: 'include', body: _.json_to_form_data({email: this.props.parent.state.email})}).then(response => response.json()).then(response => {
                if(response.status)
                    this.props.parent.setState({screen: 'activate-account'});
                else
                    this.setState({waiting_response: false, error: response.error || ''});
            });
        }
    }
    
    _onChange(text) {
        if(!this.state.waiting_response)
        {
            this.props.parent.setState({email: text});
            
            if(_.is_empty(this.state.error))
                this.setState({error: ''});
        }
    }
    
    _inputKeyDown(e) {
        if(e.key == 'Enter')
            this._requestNewPassword();
    }
    
    render() {
        return (
            <View className={['d-flex flex-column justify-content-center mx-5 p-4 p-sm-5', styles['background-color-white'], styles['container']]}>
                <View className={['w-100 d-flex flex-column justify-content-between my-5 py-4', styles['container-content']]}>
                    <View className={['d-flex flex-column']}>
                        <Text className={['mx-3 mx-sm-n3 mb-2 font-weight-bold text-center', styles['color-light-blue'], styles['f-2-2-5'], styles['f-sm-4-2-5'], styles['line-height-2-5'], styles['line-height-sm-4-5'], styles['font-montserrat']]}>Wachtwoord vergeten</Text>
                        <Text className={['mb-' + (_.is_empty(this.state.error) ? '4' : '3') + ' font-weight-light text-center', styles['font-roboto'], styles['f-1'], styles['f-sm-1-7-5'], styles['line-height-1'], styles['line-height-sm-1-5'], styles['color-grey']]}>Geef het emailadres op waar je het wachtwoord van bent vergeten.</Text>
                        {!_.is_empty(this.state.error) && (
                            <View className={[styles['background-color-red-pink-10'], styles['color-red-pink'], 'd-flex flex-row p-3 mb-4']}>
                                <FontAwesomeIcon icon={faEngineWarning} className={styles['f-3-5']} />
                                <Text className={['ml-2', styles['f-1-5'], styles['f-sm-2']]}>{this.state.error}</Text>
                            </View>
                        )}
                        <View className={['mb-2']}>
                            <CustomTextField autoFocus placeholder="Email" value={this.props.parent.state.email} onChangeText={email => this._onChange(email)} wrapper={CustomTextFieldSet} type="email" startAdornment={<InputAdornment position="start"><FontAwesomeIcon icon={faUser} className={styles['color-light-blue']} /></InputAdornment>} inputProps={{onKeyDown: this._inputKeyDown}} />
                        </View>
                        <View className={['d-flex flex-row justify-content-end justify-content-sm-end mb-4']}>
                            <TouchableArea className={[styles['color-light-blue'], styles['text-underline'], styles['f-0-7-5'], styles['f-0-5']]} onPress={() => this.props.parent.setState({screen: 'login'})}>Terug naar inlogscherm</TouchableArea>
                        </View>
                    </View>
                    <Button className={['px-4 py-2 text-center align-self-center', styles['login-button']]} {...(!this.state.waiting_response ? {onPress: this._requestNewPassword} : {})}>{!this.state.waiting_response ? (<Text className={[styles['font-montserrat'], styles['text-bold'], styles['f-1-2-5'], styles['f-sm-1-5']]}>Wachtwoord resetten</Text>) : (<ActivityIndicator />)}</Button>
                </View>
            </View>
        );
    }
}

class ActivateAcountScreen extends React.Component {
    constructor(props) {
        super(props);
        
        this.decodedHash        = JSON.parse(atob(_.get_url_params(window.location.href).hash))
        
        this.state              = {
            temp_password           : this.decodedHash.temp_password, 
            new_password            : '', 
            new_password_repeated   : '', 
            attempting_activation   : false, 
            error                   : ''
            
        };
        
        this._changePassword    = this._changePassword.bind(this);
        this._onChange          = this._onChange.bind(this);
        this._inputKeyDown      = this._inputKeyDown.bind(this);
    }
    
    _changePassword() {
        if(_.is_empty(this.state.temp_password) || _.is_empty(this.state.new_password) || _.is_empty(this.state.new_password_repeated))
            this.setState({error: 'Alle velden zijn verplicht.'});
        else if(this.state.new_password != this.state.new_password_repeated)
            this.setState({error: 'Herhaal wachtwoord komt niet overeen met wachtwoord.'});
        else
        {
            fetch(Config.SERVER_REQUEST_URL + '?ajax_id=10489&form-action=view', {method: 'POST', xhrFields: { withCredentials: true }, credentials: 'include', body: _.json_to_form_data({email: this.props.parent.state.email, ..._.pick(this.state, ['temp_password', 'new_password', 'new_password_repeated'])})}).then(response => response.json()).then(response => {
                if(response.status)
                {
                    if(response.user.id < 10000 || [10000, 10001, 10004].includes(_.format_input(response.user.group_id)))
                        window.location.href = '/';
                    else
                        this.props.parent.setState({screen: 'activation-succes', user: response.user});
                }
                else
                    this.setState({attempting_activation: false, ...(!_.is_empty(response.error) ? {error: response.error} : {})});
            });
        }
    }
    
    _onChange(field, value) {
        if(!this.state.attempting_activation)
        {
            if(field == 'email')
            {
                this.props.parent.setState({[field]: value});
                
                if(!_.is_empty(this.state.error))
                    this.setState({error: ''});
            }
            else
                this.setState({[field]: value, error: ''});
        }
    }
    
    _inputKeyDown(e) {
        if(e.key == 'Enter')
            this._changePassword();
    }
    
    render() {
        return (
            <View className={['d-flex flex-column justify-content-center mx-5 p-4 p-sm-5', styles['background-color-white'], styles['container']]}>
                <View className={['w-100 d-flex flex-column justify-content-between my-3', styles['container-content']]}>
                    <View className={['d-flex flex-column']}>
                        <Text className={['mb-1', styles['color-light-blue'], styles['f-2-2-5'], styles['f-sm-4-2-5'], styles['line-height-4-5'], styles['text-bold'], styles['text-align-center'], styles['font-montserrat']]}>Account activeren</Text>
                        <Text className={['mb-' + (!_.is_empty(this.state.error) ? '1' : '4'), styles['font-roboto'], styles['f-1'], styles['f-sm-1-7-5'], styles['line-height-1'], styles['line-height-sm-1-5'], styles['text-light'], styles['color-grey'], styles['text-align-center']]}>Er is een email naar je gestuurd met een tijdelijk wachtwoord, vul die hieronder in.</Text>
                        {!_.is_empty(this.state.error) && (
                            <View className={[styles['background-color-red-pink-10'], styles['color-red-pink'], 'd-flex flex-row p-3 mb-2']}>
                                <FontAwesomeIcon icon={faEngineWarning} className={styles['f-3-5']} />
                                <Text className={['ml-2', styles['f-1-5'], styles['f-sm-2']]}>{this.state.error}</Text>
                            </View>
                        )}
                        {this.props.parent.url_params.new_pwd && (
                            <View className={['mb-4']}>
                                <CustomTextField autoFocus placeholder="Email" value={this.props.parent.state.email} onChangeText={email => this._onChange('email', email)} wrapper={CustomTextFieldSet} type="email" startAdornment={<InputAdornment position="start"><FontAwesomeIcon icon={faEnvelope} className={styles['color-light-blue']} /></InputAdornment>} inputProps={{onKeyDown: this._inputKeyDown}} />
                            </View>
                        )}
                        <View className={['mb-4 pb-sm-3']}>
                            <CustomTextField placeholder="Tijdelijk wachtwoord" value={this.state.temp_password} onChangeText={temp_password => this._onChange('temp_password', temp_password)} wrapper={CustomTextFieldSet} type="password" startAdornment={<InputAdornment position="start"><FontAwesomeIcon icon={faLockAlt} className={styles['color-light-blue']} /></InputAdornment>} inputProps={{onKeyDown: this._inputKeyDown}} />
                        </View>
                        <View className={['mb-3']}>
                            <CustomTextField placeholder="Nieuw wachtwoord" value={this.state.new_password} onChangeText={new_password => this._onChange('new_password', new_password)} wrapper={CustomTextFieldSet} type="password" startAdornment={<InputAdornment position="start"><FontAwesomeIcon icon={faLockAlt} className={styles['color-light-blue']} /></InputAdornment>} inputProps={{onKeyDown: this._inputKeyDown}} />
                        </View>
                        <View className={['mb-4' + (!this.props.parent.url_params.new_pwd ? ' pb-3' : '')]}>
                            <CustomTextField placeholder="Wachtwoord herhalen" value={this.state.new_password_repeated} onChangeText={new_password_repeated => this._onChange('new_password_repeated', new_password_repeated)} wrapper={CustomTextFieldSet} type="password" startAdornment={<InputAdornment position="start"><FontAwesomeIcon icon={faLockAlt} className={styles['color-light-blue']} /></InputAdornment>} inputProps={{onKeyDown: this._inputKeyDown}} />
                        </View>
                    </View>
                    <Button className={['px-4 py-2 text-center align-self-center', styles['login-button']]} {...(!this.state.attempting_activation ? {onPress: this._changePassword} : {})}>{!this.state.attempting_activation ? (<Text className={[styles['font-montserrat'], styles['text-bold'], styles['f-1-2-5'], styles['f-sm-1-5']]}>Activeren</Text>) : (<ActivityIndicator />)}</Button>
                </View>
            </View>
        );
    }
}